
/**
 * Merge URL parameters
 *
 * @param {string | URL} url
 * @param {URLSearchParamsInit} params
 */
export const mergeUrlParams = (url, params) => {
	const urlObj = typeof url === 'string' ? new URL(url, window.location.href) : url;
	const urlParams = new URLSearchParams(urlObj.search);
	for (const [key, value] of (new URLSearchParams(params)).entries()) {
		urlParams.set(key, value);
	}
	urlObj.search = urlParams.toString();
	return urlObj.toString();
};